<template>
  <div class="morelineAssort">
    <!-- 多排列表 -->
    <div v-for="(item, key) in list" :key="key" @click="clickOpen(item)" class="item">
        <img :src="item.icon">
        <div>{{item.title}}</div>
    </div>
  </div>
</template>

<script>
import { cblockItem } from '@/api/app'

export default {
  name: 'MorelineAssort',
  props: ['list'],
  data () {
    return {
    }
  },
  methods: {
      clickOpen: function(item){
        cblockItem(item, this)
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.morelineAssort {
  background-color: #fff;
  padding: 13px 0 0 0;
  text-align: center;
  margin-bottom: 6px;
  display: flex;
  flex-wrap: wrap;
}
.morelineAssort .item {
    color: #333333;
    font-size: 13px;
    min-width: 80px;
    max-width: 96px;
    width: 25vw;
    margin-bottom: 13px;
}
.morelineAssort .item img{
    width: 45px;
    height: 45px;
    border-radius: 22px;
    margin: 0 auto 6px auto;
}
</style>
